import { useEffect, useState, useRef } from "react";

export function useIntersectionObserver() {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observerInstance.disconnect(); // sadece bir kere tetiklensin
        }
      },
      {
        root: null,
        rootMargin: "100px 0px", // Element görünmeden 100px önce tetikle
        threshold: 1,
      }
    );

    const currentObserver = ref?.current;
    if (currentObserver) {
      observer.observe(currentObserver);
    }

    return () => {
      if (currentObserver) {
        observer.unobserve(currentObserver);
      }
    };
  }, []);

  return [ref, isVisible];
}
